import React from 'react';
import './StatusMessage.css';

export interface StatusMessageProps {
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
  onClose?: () => void;
  className?: string;
  style?: React.CSSProperties;
}

export const StatusMessage: React.FC<StatusMessageProps> = ({
  type,
  message,
  onClose,
  className = '',
  style = {}
}) => {
  const getIcon = () => {
    switch (type) {
      case 'success':
        return ''; // Remove icon for success messages
      case 'error':
        return ''; // Remove icon for error messages
      case 'warning':
        return '⚠️';
      case 'info':
        return 'ℹ️';
      default:
        return '';
    }
  };

  return (
    <div className={`status-message ${type} ${className}`} style={style}>
      <div className="status-message-content">
        <span className="status-message-icon">{getIcon()}</span>
        <span className="status-message-text">{message}</span>
      </div>
      {/* Remove close button for success and error messages */}
      {onClose && type !== 'success' && type !== 'error' && (
        <button
          className="status-message-close"
          onClick={onClose}
          aria-label="Close message"
          type="button"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default StatusMessage;
